import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/mobilede-alternativa/")({
  head: () => routeHead("/mobilede-alternativa/"),
  beforeLoad: () => {
    throw redirect({ href: "/ghiduri/platforme-auto-romania-cum-alegi", statusCode: 301, replace: true });
  },
});
